var _mask, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBubble = function SvgBubble(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "bubble_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9 18a9 9 0 1 0-7.703-4.342L.117 17.86l4.193-1.177A8.96 8.96 0 0 0 9 18",
    clipRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    fillRule: "evenodd",
    d: "M9 18a9 9 0 1 0-7.703-4.342L.117 17.86l4.193-1.177A8.96 8.96 0 0 0 9 18",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m1.297 13.658 1.926.54.235-.835-.45-.742zM.117 17.86l-1.925-.54-.964 3.43 3.43-.964zm4.193-1.177 1.044-1.706-.745-.456-.84.236zM16 9a7 7 0 0 1-7 7v4c6.075 0 11-4.925 11-11zM9 2a7 7 0 0 1 7 7h4C20 2.925 15.075-2 9-2zM2 9a7 7 0 0 1 7-7v-4C2.925-2-2 2.925-2 9zm1.008 3.621A6.96 6.96 0 0 1 2 9h-4c0 2.08.58 4.032 1.587 5.694zm-.965 5.78 1.18-4.203-3.851-1.081-1.18 4.203zm1.726-3.644-4.193 1.178 1.082 3.85 4.193-1.177zM9 16a6.96 6.96 0 0 1-3.646-1.023l-2.088 3.412A10.96 10.96 0 0 0 9 20z",
    mask: "url(#bubble_svg__a)"
  })));
};
export default SvgBubble;